
import {Component, EventEmitter, Input, OnInit, OnDestroy, Output, ViewChildren, QueryList} from '@angular/core';
import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import {Subscription as RxJsSubscription} from 'rxjs';
import {ErrorService, ExplainErrorsService, SessionService} from '@app/services';
import { environment } from '@env/environment';
import {TextTranslated} from '../text-translated';
import {TextTranslatedService} from '../text-translated.service';
import { LanguageTabComponent } from '@app/models/language';
@Component({
  selector: 'hpf-text-translated-form',
  templateUrl: './text-translated-form.component.html'
})
export class TextTranslatedFormComponent implements OnInit, OnDestroy {
  /** The model subscription */
  private modelSubscription: RxJsSubscription;
  /** The text translated to inject in the form */
  @Input() textTranslated: TextTranslated;
  /** Called the save button is clicked for a new instance */
  @Output() create = new EventEmitter<TextTranslated>();
  /** Called the save button is clicked for an existing instance */
  @Output() update = new EventEmitter<void>();
  /** Called the delete button is clicked */
  @Output() delete = new EventEmitter<void>();
  /** Set loading state of the form */
  @Input() loading = false;
  /** Enable the deletion button */
  @Input() deletable = true;
	/** Enabled quick form */
	@Input() quickFormEnabled = environment.plugins.quickForm.enabled;
  /** Denotes if deltion in progress */
  deleting = false;
  /** Show delete modal */
  deleteModal = false;
  /** The form group to use */
  form: FormGroup;
  /** Denotes if the form is pending */
  saving = false;
  /** Check permission of update **/
  readOnly = false;
	@ViewChildren(LanguageTabComponent) languageTabs: QueryList<
		LanguageTabComponent
	>;
  /** Constructor */
  constructor(private formBuilder: FormBuilder,
              private errorService: ErrorService,
              public explainErrorsService: ExplainErrorsService,
              private textTranslatedService: TextTranslatedService,
              private sessionService: SessionService) {
  }
  /** Init */
  async ngOnInit() {
    this.readOnly = !(await this.sessionService.checkPermission(
			'text_translated',
			'update'
		));

    // Init model
    if(!this.textTranslated) this.textTranslated = new TextTranslated();

    // Create form
    this.form = this.formBuilder.group({
    name: new FormControl(this.textTranslated.props.name, [Validators.required]),
    text: new FormControl(this.textTranslated.props.text, [Validators.required]),
    lang: new FormControl(this.textTranslated.props.lang, [Validators.required]),
    });
    // Update form when model loads or changes
    this.modelSubscription = this.textTranslated.subscribe(() => {
        this.updateForm();
    });
  }
  /** Destroy */
  ngOnDestroy() {
    this.modelSubscription.unsubscribe();
  }
  /** Called on form submit */
  async onSubmit(): Promise<void> {
    // Saving flag
    this.saving = true;
    try {
        // Update model
        this.updateModel();
		for (let element of this.languageTabs) {
				await element.submit();
			}
        // Creation or update ?
        if (this.textTranslated.isNew()) {
            // Creation
            const textTranslated: TextTranslated = await this.textTranslatedService.create(this.textTranslated.toPayload());
            this.create.next(textTranslated);
        } else {
            // Update
            await this.textTranslatedService.update(this.textTranslated.getId(), this.textTranslated.toPayload());
            this.update.next();
        }
    } catch (error) {
        this.errorService.handle(error);
    }
    // Saving flag
    this.saving = false
  }
  /** Update models properties from inputs values */
  private updateModel(): void {
    for (const key of Object.keys(this.form.controls)) {
        this.textTranslated.props[key] = this.form.get(key).value;
    }
  }
  /** Update inputs values from models properties */
  private updateForm(): void {
    this.form.setValue({
      'name': this.textTranslated.props.name,   
      'text': this.textTranslated.props.text,   
      'lang': this.textTranslated.props.lang,   
    });
  }
  /** Called on deletion */
  onDelete(): void {
    this.deleting = true;
    this.textTranslatedService.remove(this.textTranslated.getId())
      .then(() => {
        this.delete.next();
      })
      .catch((error) => this.errorService.handle(error))
      .then(() => this.deleting = false);
  }
}
